import {
	ADMINGETRISKRULELIST_SUCCESS,
	ADMINGETRISKRULELIST_FAILED,
	RESET_ADMINGETRISKRULELIST,
	LOADING_ADMINGETRISKRULELIST,
	NETWORK_ERROR_ADMINGETRISKRULELIST
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINGETRISKRULELIST:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case ADMINGETRISKRULELIST_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case ADMINGETRISKRULELIST_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_ADMINGETRISKRULELIST:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_ADMINGETRISKRULELIST:
			return (state = initialState);
		default:
			return state;
	}
};
